import { graphql, useLazyLoadQuery } from "react-relay";
import { useParams } from "react-router";

import { NotificationsSettingsPage } from "../../settings/components/NotificationsSettingsPage";
import { UpsertNotificationRuleStepsContainer } from "../components/UpsertNotificationRuleStepsContainer";
import { NotificationRuleFormContextProvider } from "../contexts/NotificationRuleFormContext";
import { EditNotificationRuleHeader } from "./EditNotificationRuleHeader";

import type { EditNotificationRuleRootQuery } from "./__generated__/EditNotificationRuleRootQuery.graphql";

export function EditNotificationRuleRoot() {
  const { ruleUUID } = useParams<"ruleUUID">();
  const data = useLazyLoadQuery<EditNotificationRuleRootQuery>(
    graphql`
      query EditNotificationRuleRootQuery($uuid: UUID!) {
        notificationRule(uuid: $uuid) {
          ...UpsertNotificationRuleStepsContainer_notificationRule
          uuid
          name
        }
        ...NotificationsSettingsPage_query
      }
    `,
    { uuid: ruleUUID ?? "" },
  );

  if (!data.notificationRule?.uuid) {
    return (
      <div className="text-body-small text-text-secondary">
        No notification rule found with this uuid.
      </div>
    );
  }

  return (
    <NotificationsSettingsPage
      queryRef={data}
      title="Edit Notification Rule"
      withHeader={false}
    >
      <NotificationRuleFormContextProvider
        ruleUUID={data.notificationRule.uuid}
        isEditMode
      >
        <EditNotificationRuleHeader name={data.notificationRule.name} />
        <UpsertNotificationRuleStepsContainer
          notificationRule={data.notificationRule}
        />
      </NotificationRuleFormContextProvider>
    </NotificationsSettingsPage>
  );
}
